import { render, staticRenderFns } from "./InvoicingConnection.vue?vue&type=template&id=3218bb15&scoped=true"
import script from "./InvoicingConnection.vue?vue&type=script&lang=js"
export * from "./InvoicingConnection.vue?vue&type=script&lang=js"
import style0 from "./InvoicingConnection.vue?vue&type=style&index=0&id=3218bb15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3218bb15",
  null
  
)

export default component.exports